/**
 * Enum enumerating Tooltip positions for Angular Material Tooltip directive. Reflects `TooltipPosition` type
 * from Angular Material.
 *
 * @link https://material.angular.io/components/tooltip/api#TooltipPosition
 */
export enum MatTooltipPosition {
    LEFT = 'left',
    RIGHT = 'right',
    ABOVE = 'above',
    BELOW = 'below',
    BEFORE = 'before',
    AFTER = 'after',
}
